export default function (pageName: string, path: string) {
  return {
    pageName,
    pageId: '26011',
    pagePath: path,
    common: {
      source: 2,
      typeId: 'opinion_pc_v2',
    },
  };
}
